// extracted by mini-css-extract-plugin
export default {"root":"W8TdBd","title":"FVqXXA","subtitle":"LyckqV","centered":"E0XeFB","mobile":"bguNSb","page":"F7O66B","section":"xggLUk","transparent":"qbsCtK","action":"ss8Q6l"};